import CONST from "../config/CONST";

export const piwikTracker = (function ($) {

    /***
     PIWIK TRACKING SCRIPT

     add in event dom class="js-track" data-track="category|action|label"
     label is optional

     ****/


    function init() {
        if (window._paq && typeof window._paq.push && typeof window._paq.push === 'function') {

            setTimeout(function () {

                // setting const inside a timeout to manage click with react components too
                const $track = $(".js-track");

                $track.on("click", function (e) {
                    e.preventDefault();
                    piwikGetDataTrackerClick(jQuery(this));

                    //  if js-track has href goto link
                    let href = jQuery(this).attr('href');
                    let target = jQuery(this).attr('target') || '';
                    if (href !== undefined && href !== '#') {
                        if (target === '_blank') {
                            window.open(href, target);
                        } else {
                            location.href = href;
                        }
                    }
                });

            }, 3000);
        }
    }

    function piwikGetDataTrackerClick(link) {
        let data = link.data('track');
        let result = data.split('|');
        if(CONST.DEBUG) {
            console.log('piwikGetDataTrackerClick:', result);
        }
        piwikTrackerClick(result[0], result[1], result[2]);
    }

    function piwikTrackerClick(category, action, name) {

        if (name === undefined) {
            name = "";
        }
        if(CONST.DEBUG) {
            console.log('piwikTrackerClick:', category + ' - ' + action + ' - ' + name);
        }
        _paq.push([
            "trackEvent",
            category,
            action,
            name
        ]);
    }

    return {
        init: init
    }

})(jQuery);
